import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {Property} from "../model/property";
import {Observable} from "rxjs";
import {ServiceInformation} from "../model/serviceInformation";

@Injectable({
  providedIn: 'root'
})
export class ContactService {

  constructor(private httpClient: HttpClient) { }

  /**
   * Get the service information for a specific property using its town and zip.
   * Currently the service information are only gotten for the document 'teilun' and are used to determine
   * if the 'teilung' document is obtainable on site.
   *
   * @param property Property for which the service information should be gotten
   */
  public getPropertyServiceInformationForTeilun(property : Property): Observable<ServiceInformation>{
    const requestParameter = `?town=${property.town}&zip=${property.zip}&docName=teilun`;

    return this.httpClient.get<ServiceInformation>("/api/service-information" + requestParameter, {headers: new HttpHeaders({'showing-spinner': ''})})
  }

  /**
   * Retrieves the country state name for the specified townName and zip
   *
   * @param townName TownName for which the country state should be retrieved
   * @param zip Zip for which the country state should be retrieved
   * @return Observable Emitting a string representing the country state name if found or else null
   */
  public getCountryStateName(townName: string, zip: string): Observable<string | null>{
    return this.httpClient.get<string | null>(`/api/country-state-name?townName=${townName}&zip=${zip}`, {responseType: 'text' as 'json', headers: new HttpHeaders({'showing-spinner': ''})});
  }

}
